import { IPaymentDay, PaymentDayEnum } from 'typescript/interfaces/paymentDay'

export const paymentDays: IPaymentDay[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']

export const paymentDayShortLabels: { [key in PaymentDayEnum]: string } = {
  [PaymentDayEnum.Monday]: 'Mon',
  [PaymentDayEnum.Tuesday]: 'Tue',
  [PaymentDayEnum.Wednesday]: 'Wed',
  [PaymentDayEnum.Thursday]: 'Thu',
  [PaymentDayEnum.Friday]: 'Fri',
}

export const getPaymentDayFromDate = (date?: string | null): IPaymentDay => {
  const parsed = date ? new Date(date) : null
  const weekdayIndex = parsed && !Number.isNaN(parsed.getTime()) ? parsed.getDay() - 1 : -1

  return paymentDays[weekdayIndex] ?? PaymentDayEnum.Monday
}
